<template>
  <el-tabs v-model="activeTab" type="border-card" class="dense truckload">
    <el-tab-pane name="tls">
      <span slot="label"> <i class="fas fa-truck"></i> TL </span>
      <TlList />
    </el-tab-pane>
    <el-tab-pane name="bols" v-if="isAdmin">
      <span slot="label"> <i class="fas fa-cubes"></i> BOL </span>
      <BolList />
    </el-tab-pane>
    <el-tab-pane name="ltls" :lazy="true" v-if="isAdmin">
      <span slot="label"> <i class="fas fa-truck"></i> LTL </span>
      <LtlList />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import TlList from "@/default/pages/tls/list.vue";
import BolList from "@/default/pages/bols/list.vue";
import LtlList from "@/default/pages/ltls/list.vue";
export default {
  name: "Truckload",
  components: {
    BolList,
    LtlList,
    TlList,
  },
  data() {
    return {
      activeTab: "tls",
    };
  },
};
</script>
<style lang="scss" scoped>
.truckload::v-deep {
  .el-tabs__item {
    padding: 0px 20px !important;
  }

  .el-tabs__content {
    height: calc(100vh - 155px);
    overflow: auto;
  }
}
</style>
